import { render, staticRenderFns } from "./AtsConnect.html?vue&type=template&id=3ff4ce36&scoped=true&external"
import script from "./AtsConnect.js?vue&type=script&lang=js&external"
export * from "./AtsConnect.js?vue&type=script&lang=js&external"
import style0 from "./AtsConnect.scss?vue&type=style&index=0&id=3ff4ce36&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff4ce36",
  null
  
)

export default component.exports